import { render, staticRenderFns } from "./SubUser.vue?vue&type=template&id=0754613f"
import script from "./SubUser.vue?vue&type=script&lang=js"
export * from "./SubUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports